/**
 * Floating panel header — eyebrow + title + subtitle. Mirrors the
 * prototype's `.panel-head` block (`_archive/map.html` lines 141-156 +
 * the body content at lines 490-493):
 *
 *   eyebrow:  10px / 800 / .13em uppercase blue
 *   title:    16px / 800 / -.02em / line-height 1.2 / text-1
 *   subtitle: 12px / text-4 / line-height 1.5
 *   container padding 18/20/14, border-bottom 1px var(--border)
 */
export function MapPanelHead() {
  return (
    <header className="flex-shrink-0 border-b border-border bg-white px-5 pb-[14px] pt-[18px]">
      <p className="mb-1 text-[10px] font-extrabold uppercase tracking-[0.13em] text-blue-link">
        Map Explorer
      </p>
      <h2 className="mb-1 text-[16px] font-extrabold leading-[1.2] tracking-[-0.02em] text-text-1">
        Credentials-to-Jobs Alignment
      </h2>
      {/* 2026-07-02 (Georgetown copy refresh): sentence now anchors
          the demand side to "springboard occupations" so the sidebar
          intro reads consistently with the rest of the tool. */}
      <p className="text-[12px] leading-[1.5] text-text-4">
        Explore how 55 metro areas align credential production with projected
        workforce demand in springboard occupations.
      </p>
    </header>
  );
}
